<template>
  <div>
    <mrc_ess_table :headers="headers"
                   v-if="$route.name == 'role'"
                   pageName="addRole"
                   :hideAddBtn="!hasBtn('add-role')"
                   :paginationOptions="paginationOptions"
                   @turnPage="getList"
                   :isLoading="loading"
                   :slotKey="['org_level_uuid', 'role_name', 'is_used']"
                   :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end"
               style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4"
                                               v-model="systemSeniorQueryString"
                                               @success="getList({ cpage: 1 })"
                                               :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.org_level_uuid="{ item }">
        <!-- <div style="white-space: nowrap;;overflow: hidden;"
             class="d-flex align-center">
          <div style="width: 90%;white-space: nowrap;;overflow: hidden;">

          </div>

        </div> -->
        <mrc_ess_chip v-for="(items, index) in splitINT(item.org_level_uuid)"
                      v-show="item.org_level_uuid.length > 0"
                      :key="index"
                      small
                      class="mr-1 my-1">
          {{ INT(items) }}
        </mrc_ess_chip>
      </template>

      <template v-slot:item.role_name="{ item }">
        <span class="text-body-s">{{ INT(item.role_name) }}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="desc text--secondary text-caption"
                 v-bind="attrs"
                 v-on="on">
              {{ INT(item.role_description) }}
            </div>
            <!-- <div class="role_name">
         
            </div> -->
          </template>
          <span>{{ INT(item.role_description) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.actions="{ item }">
        <menu-list :list="list"
                   @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="['view-role', 'edit-role', 'delete-role']">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
      <template v-slot:item.is_used="{ item }">
        <mrc_ess_viewbtn :is_used="item.is_used_save_value"
                         :label="item.is_used">
        </mrc_ess_viewbtn>
        <!-- {{ INT(item.is_used) }} -->
        <!-- <span class="status"
              :class="{'is_used': !item.is_used}">{{item.is_used ? $t('label_To_enable_the') : $t('label_disable')}}</span> -->
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { role_list, role_del } from "@/service/api/role"
import { getBusinessList } from "@/service/api/prompt"
export default {
  components: {},
  props: {},
  data () {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  beforeCreate () {
    this.$store.commit("setCpage", 1)
  },
  async created () {
    await this.getBtnPermissionList()
  },
  async mounted () {
    if (this.$route.name == "role") {
      await this.getList()
    }
  },
  beforeDestroy () { },
  methods: {
    /**
     * @description: 获取角色列表
     * @param {type}
     * @return:
     * @author: lwq
     */
    async getList (obj) {
      if (obj) {
        this.paginationOptions = { ...this.paginationOptions, ...obj }
      }
      this.loading = true
      const list = await role_list({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        org_level_uuid: this.$store.state.currentCompany,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (list.code == 200) {
        list.data.forEach((item) => {
          if (item.name)
            item.name =
              item.name.indexOf(",") != -1 ? item.name.split(",") : [item.name]
          else item.name = []
        })
        this.desserts = list.data
        this.paginationOptions.totalcount = list.totalcount
        this.paginationOptions.totalpage = list.totalpage
        this.systemFieldMeta = list.systemFieldMeta
        this.field_alias_name = list.field_alias_name
        this.table_alias_name = list.table_alias_name
      }
      this.loading = false
    },
    /**
     * @description: 进入详情
     * @param {index} 点的第几个menu
     * @param {item} 点的整条数据
     * @return:
     * @author: lwq
     */
    handleClick ({ item, index }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_subPage_name", obj.role_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "roleInfo",
          params: {
            name: obj.role_name,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "edit") {
        this.$store.commit("set_subPage_name", obj.role_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "roleInfo",
          params: {
            name: obj.role_name,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await role_del({
              uuid: obj.uuid,
            })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => { })
      }
    },
    /**
     * @description: 去添加页面
     * @param {type}
     * @return:
     * @author: lwq
     */
    handleAdd () {
      this.$router.push({
        name: "addRole",
      })
    },
  },
  computed: {
    list () {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-role"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-role"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-role"),
          type: "del",
        },
      ]
    },
    headers () {
      return [
        {
          text: this.$t("label_role"),
          align: "start",
          sortable: false,
          value: "role_name",
        },
        {
          // text: this.$t("label_Use_the_unit"),
          text: this.$t('label_role_m_client'),
          align: "start",
          sortable: false,
          value: "org_level_uuid",
        },
        {
          text: this.$t("label_use_people"),
          align: "start",
          sortable: false,
          value: "userNum",
        },
        {
          text: this.$t("label_state"),
          align: "start",
          sortable: false,
          value: "is_used",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
  },
  watch: {
    async $route (val) {
      if (val.name == "role") {
        await this.getList()
        this.$store.commit("setTab", 0)
      }
    },
  },
}
</script>

<style scoped>
.role_name {
  display: flex;
  flex-direction: column;
}
.name {
  font-size: 16px;
}
.desc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.org_level_name {
  overflow: hidden;
  padding: 10px;
  white-space: nowrap;
  max-width: 30vw;
}
</style>
